import { IScrubAdapter } from './IScrubAdapter';

export class DefaultScrubAdapter implements IScrubAdapter {
	constructor(
		public readonly getCurrentTime: () => number,
		public readonly getDuration: () => number
	) { }

	public onScrubClick(xFactor: number): number {
		let seekTimeMs = xFactor * this.getDuration();
		seekTimeMs = Math.max(0, Math.min(seekTimeMs, this.getDuration()));
		return seekTimeMs;
	}

	public onSeekRelativeTime(dt: number): number {
		return Math.max(0, Math.min(this.getCurrentTime() + dt, this.getDuration()));
	}

	public onScrubTime(t: number): number {
		return t;
	}

	public onPlayback(t: number): void {
		//noop
	}
}
